<template>
  <div class="area-content">
    <div class="mainArea">
      <div class="imageArea">
        <img src="../../assets/img/feedback.png" alt="" style="width: 120px; height: 120px" />
      </div>
      <div class="descTip">{{ title ? title : '报错信息未知' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payFeedback',
  data: function () {
    return {
      title: ''
    };
  },
  async created() {
    document.title = '支付反馈';
    let params = this.getQuery();
    console.log('xxx44:参数', params);
    if (params && params.title) {
      this.title = params.title;
    } else {
      // this.$message.error('抱歉，未拿取到出错信息');
      return false;
    }
  },
  mounted() {},
  methods: {
    // 获取网址参数
    getQuery() {
      let href = window.location.href; //获取url
      href = decodeURI(href); //使用 decodeURI() 对一个编码后的 URI 进行解码：
      //或者使用decodeURIComponent(href)
      let query = href.substring(href.indexOf('?') + 1); //获取？后面的参数部分
      let param = query.split('&'); //将参数部分-用&分割，转换成数组
      let obj = {};
      for (var i = 0; i < param.length; i++) {
        let per = param[i].split('='); //将数组中的每一项-用=分割，转换成数组
        obj[per[0]] = per[1]; //以键值对的形式储存
      }
      return obj;
    },
    // 获取网址参数
    // getParamsFromURL() {
    //   let url = window.location.href; //获取url
    //   if ('undefined' == url) {
    //     return {};
    //   }
    //   let paraString = url.substring(url.indexOf('?') + 1, url.length).split('&');
    //   let paraObj = {};
    //   for (let i = 0; i < paraString.length; i++) {
    //     let j = paraString[i];
    //     paraObj[j.substring(0, j.indexOf('='))] = j.substring(j.indexOf('=') + 1, j.length);
    //   }
    //   return paraObj;
    // },
  }
};
</script>

<style lang="scss" scoped>
.area-content {
  height: 100vh;
  width: 100vw;
  // overflow-y: scroll;
  box-sizing: border-box;
}
.mainArea {
  width: 100vw;
  height: auto;
  padding-top: 100px;
  // border: 1px solid red;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.imageArea {
  width: 100vw;
  height: auto;
  display: flex;
  // flex-wrap: wrap;
  justify-content: center;
}
.descTip {
  width: 100vw;
  padding: 0 20px;
  box-sizing: border-box;
  margin-top: 20px;
  font-size: 16px;
  color: red;
  text-align: center;
}
</style>
